import { createAction, props } from '@ngrx/store';
import { InHospitalList, InHospitalListItem } from 'src/app/types/aggregate-graph/in-hospital-list/aggregate-graph.types';

export enum InHospitalListGraphActionTypes {
	InHospitalListGenerated = '[In Hospital List Graph Effect] In Hospital List Generated',
	InHospitalListItemAdded = '[In Hospital List Graph Effect] In Hospital List Item Added',
	InHospitalListItemChanged = '[In Hospital List Graph Effect] In Hospital List Item Changed',
	InHospitalListItemRemoved = '[In Hospital List Graph Effect] In Hospital List Item Removed',
	InHospitalListSortDirectionChanged = '[Component] In Hospital List Sort Direction Changed'
}

export const inHospitalListGenerated = createAction(
	InHospitalListGraphActionTypes.InHospitalListGenerated,
	props<{ list: InHospitalList }>()
)

export const inHospitalListItemAdded = createAction(
	InHospitalListGraphActionTypes.InHospitalListItemAdded,
	props<{ item: InHospitalListItem }>()
)

export const inHospitalListItemChanged = createAction(
	InHospitalListGraphActionTypes.InHospitalListItemChanged,
	props<{ item: InHospitalListItem }>()
)

export const inHospitalListItemRemoved = createAction(
	InHospitalListGraphActionTypes.InHospitalListItemRemoved,
	props<{ sheetId: string }>()
)

export const inHospitalListSortDirectionChanged = createAction(
	InHospitalListGraphActionTypes.InHospitalListSortDirectionChanged
)
